import React from 'react'
import { AuthProvider } from './auth'

function AppProvider(props) {
  return <AuthProvider>{props.children}</AuthProvider>
}

export { AppProvider }
